/**
 * @generated SignedSource<<b2625bf4850405e1948b5e9861d9758e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetEmployeeScheduleInput = {
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
  teamIds?: ReadonlyArray<string> | null;
};
export type WAEmployeeScheduleMutation$variables = {
  input: CreateWidgetEmployeeScheduleInput;
  storecastId: string;
};
export type WAEmployeeScheduleMutation$data = {
  readonly dashboard: {
    readonly createWidgetEmployeeSchedule: {
      readonly id: string;
    };
  };
};
export type WAEmployeeScheduleMutation = {
  response: WAEmployeeScheduleMutation$data;
  variables: WAEmployeeScheduleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetEmployeeSchedule",
        "kind": "LinkedField",
        "name": "createWidgetEmployeeSchedule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAEmployeeScheduleMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAEmployeeScheduleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bd0338802a48ed906a0171e3847a3f65",
    "id": null,
    "metadata": {},
    "name": "WAEmployeeScheduleMutation",
    "operationKind": "mutation",
    "text": "mutation WAEmployeeScheduleMutation(\n  $storecastId: ID!\n  $input: CreateWidgetEmployeeScheduleInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetEmployeeSchedule(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2eccc25cac97e0ca74f7e68bbb85da89";

export default node;
